module.exports = "/assets/data/60884b794810328cfa138e87438f1471-LU2.data.json";